"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./iconSVG.css");
var _excluded = ["color", "title", "iconClass", "ariaHidden", "className", "children"];
function getIconClassNames(color, iconClass, className) {
  var classnames = ['lm-Icon', 'lm-Icon-' + iconClass.replace(/[^A-Z0-9]/gi, '')];
  if (color) {
    classnames.push('lm-Icon--color-' + color);
  }
  if (className) {
    classnames.push(className);
  }
  return classnames.join(' ');
}
var IconSVG = function IconSVG(_ref) {
  var color = _ref.color,
    title = _ref.title,
    iconClass = _ref.iconClass,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    className = _ref.className,
    children = _ref.children,
    nativeProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var aria = {};
  if (ariaHidden) {
    aria['aria-hidden'] = true;
  }
  if (title && !ariaHidden) {
    aria['aria-label'] = title;
  }
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    className: getIconClassNames(color, iconClass, className)
  }, aria, nativeProps), children, title && /*#__PURE__*/_react.default.createElement("rect", {
    width: "100%",
    height: "100%",
    style: {
      opacity: 0
    }
  }, /*#__PURE__*/_react.default.createElement("title", null, title)));
};
IconSVG.propTypes = {
  /**
   * By default, icons display in Liberty Blue. See notes on proper usage of restricted icon colors.
   * Usage of teal must be pre-approved by the design system team.
   * When modifying color types, make sure to update IconSVG.d.ts as well as react-d-ts.js script
   */
  color: _propTypes.default.oneOf(['active', 'blue', 'caution', 'disabled', 'error', 'gray', 'informative', 'inverse', 'negative', 'positive', 'success', 'teal', 'warn']),
  /** @ignore internal icon class name value */
  iconClass: _propTypes.default.string.isRequired,
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional, additional className for icon. */
  className: _propTypes.default.string,
  /** SVG path(s). */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired
};
var _default = IconSVG;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/components/IconSVG.js
// module id = 6
// module chunks = 0